import type {
  AuthoritativeMasteryState,
  LearnerInsight,
  LearnerInsightCategory,
  LearnerInsightInput,
  LearnerSkillInsight,
} from './learnerInsightTypes';

export function classifyMasteryState(state: AuthoritativeMasteryState): LearnerInsightCategory | null {
  if (state === 'mastered' || state === 'provisional_mastery') return 'strong';
  if (state === 'review_due' || state === 'needs_review' || state === 'remedial') return 'attention';
  if (state === 'available' || state === 'learning' || state === 'practicing') return 'learning';
  return null;
}

export function buildLearnerInsight(input: LearnerInsightInput): LearnerInsight {
  const skillGroups: LearnerInsight['skillGroups'] = {
    strong: [],
    learning: [],
    attention: [],
  };

  let lastActivityAt: string | null = null;

  for (const skill of input.skills) {
    const category = classifyMasteryState(skill.masteryState);
    if (!category) continue;

    const insight: LearnerSkillInsight = { ...skill, category };
    skillGroups[category].push(insight);

    if (skill.lastActivityAt && (!lastActivityAt || skill.lastActivityAt > lastActivityAt)) {
      lastActivityAt = skill.lastActivityAt;
    }
  }

  return {
    learner: input.learner,
    subject: input.subject,
    currentLevel: input.currentLevel,
    skillGroups,
    recentSessions: [...input.recentSessions],
    authorizedNotes: [...input.notes],
    guardianSharedNotes: input.notes.filter((note) => note.visibility === 'guardian_shared'),
    lastActivityAt,
    updatedAt: input.updatedAt,
  };
}
